import { useParams, useLocation } from "react-router-dom";
import ActivityForm from "../../../components/activity/ActivityForm";

const EditActivity = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const activity = location.state?.activity;

  // Transform activity data to form format
  const initialData = activity ? {
    activityName: activity.activity_name,
    patientGroup: activity.patient_group_id?.toString() || "",
    userGroup: activity.user_group_id?.toString() || "",
    initialWorkflow: activity.workflow_id?.toString() || "",
  } : undefined;

  return <ActivityForm initialData={initialData} isEdit={true} activityId={activity?.activity_id} />;
};

export default EditActivity;